import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Spinner } from "../../../../../../components/Commons/Spinner/Spinner";
import { Box, Checkbox, FormControlLabel, Grid } from "@mui/material";
import { GenericDialog } from "../../../../../../components/Dialogs/Dialog";
import { DialogEntity } from "../../../../../../components/Dialogs/DialogEntity";
import GenericPromises from "../../../../../../api/GenericPromises";
import useSnackBar from "../../../../../../components/Commons/SnackBar/useSnackBar";
import { Menuitem } from "../../../../../../interfaces/Security/menu";
import { usePermissions } from "../../../../../../hooks/usePermissions";
import { defaultTheme } from "../../../../../../theme/theme";
import { AddProjectStages } from "./add";
import { Header } from "../../../../../../components/Header";
import { StagesContainer } from "../../../../../../theme/projects/Containers/stagesContainer";
import { StageButton } from "../../../../../../theme/projects/Buttons/stageButton";
import { StageItem } from "../components/stageItem";
import { FieldType } from "../../../../../../interfaces/Projects/Catalogs/fieldTypes";
import { useProjectStagesStore } from "../../../../../../store/Projects/ProjectDetails/ProjectStagesStore";

interface TableProjectStagesProps {
  projectId: number | undefined,
  comboFieldTypes: FieldType[];
}

export const TableProjectStages = ({
  projectId,
  comboFieldTypes,
}: TableProjectStagesProps) => {
  const [t] = useTranslation("global");
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [dataloaded, setDataLoaded] = useState(false);
  const { GenericGetResource, GenericDeleteResource } = GenericPromises();
  const { showSnackBar, SnackbarComponent } = useSnackBar();
  const [openDialogAddStage, setOpenDialogAddStage] = useState(false);
  const [resourceScreen, setResourceScreen] = useState<Menuitem>();
  const { GetResourceByUrl } = usePermissions();
  const [color, setColor] = useState<number[]>();
  const projectStages = useProjectStagesStore(store => store.projectStages);
  const setProjectStages = useProjectStagesStore(store => store.setProjectStages);

  const hexToRgb = (hexColor: string) => {
    hexColor = hexColor.replace("#", "");

    const red = parseInt(hexColor.substring(0, 2), 16);
    const green = parseInt(hexColor.substring(2, 4), 16);
    const blue = parseInt(hexColor.substring(4, 6), 16);

    return [red, green, blue];
  };

  const onDelete = async () => {
    GenericDeleteResource(`/projects/${projectId}`)
      .then(() => {
        setOpenDialog(false);
        navigate("/projects", {
          state: { method: "delete" },
          replace: true,
        });
      })
      .catch((error) => {
        showSnackBar(error.message, "error");
        setOpenDialog(false);
      });
  };


  useEffect(() => {
    GenericGetResource(`/projectstages/evaluated/byprojectid/${projectId}`)
      .then(async (response) => {
        setProjectStages(response.data.data);
        setColor(hexToRgb(defaultTheme.palette.primary.main));
        GetResourceByUrl(`/projectstages`)
          .then((response1) => {
            setResourceScreen((prev) => response1);
            setDataLoaded(true);
          })
          .catch((error) => {
            showSnackBar(error.message, "error");
          });
      })
      .catch((error) => {
        showSnackBar(error.message, "error");
      });
  }, []);

  return (
    <>
      {!dataloaded && <Spinner />}
      {dataloaded && resourceScreen?.read && (
        <>
          <div className="d-flex justify-content-center mt-4">
            <StagesContainer>
              {projectStages
                .sort(
                  (a, b) =>
                    Number(a.project_stage_consecutive) -
                    Number(b.project_stage_consecutive)
                )
                .map((stage) => (
                  <StageItem key={stage.project_stage_id}
                    resourceScreen={resourceScreen}
                    isEdit={!resourceScreen?.update}
                    stage={stage}
                    color={color}
                    comboFieldTypes={comboFieldTypes}
                  />
                ))}
              {resourceScreen?.create == true && (
                <Grid item xs={8} md={5} style={{ flexShrink: 0 }}>
                  <StageButton
                    color={color}
                    onClick={() => setOpenDialogAddStage(true)}
                  >
                    {t("projectstages.actions.create")}
                  </StageButton>
                </Grid>
              )}
            </StagesContainer>
          </div>
        </>
      )}
      <GenericDialog
        title={t("generic.dialog.delete")}
        content={t("projecttypes.dialog.delete")}
        open={openDialog}
        setOpen={setOpenDialog}
        onAcept={onDelete}
      />
      <DialogEntity
        content={
          <AddProjectStages
            setOpenDialog={setOpenDialogAddStage}
            project_id={projectId}
            comboFieldTypes={comboFieldTypes}
          />
        }
        open={openDialogAddStage}
        setOpen={setOpenDialogAddStage}
        title={<Header title={t("projectstages.title-view")} size="sm" />}
      />
      <SnackbarComponent />
    </>
  );
};
